import React from 'react';

export function EmptyRoute() {
  return (
    <div>
      Nothing to see here.
    </div>
  );
}
